import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Car, Droplet, Zap, Heart, BookOpen, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Page, Spinner } from "@/components/shared";

const CAT_ICON = { ride: Car, hydration: Droplet, charging: Zap, wellness: Heart, support: BookOpen };
const CAT_COLOR = { ride: "var(--cs-green)", hydration: "var(--cs-blue)", charging: "var(--cs-amber)", wellness: "var(--cs-magenta)", support: "var(--cs-blue)" };

export default function Wallet() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => api.get("/me/wallet").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const redeem = async (b) => {
    if (b.cta === "ride") { window.open("https://m.uber.com/", "_blank"); }
    if (b.cta === "resources") { nav("/app/help"); return; }
    try {
      await api.post(`/wallet/redeem/${b.id}`);
      toast.success(`Claimed: ${b.title}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not claim"); }
  };

  if (!items) return <div className="px-6 pt-10"><Spinner /></div>;

  return (
    <Page className="px-5 pt-6">
      <button data-testid="wallet-back" onClick={() => nav("/app")} className="cs-tap flex items-center gap-1 text-sm mb-4" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Home
      </button>
      <h1 className="font-head font-extrabold text-3xl">Safety Wallet</h1>
      <p className="mt-1 text-base" style={{ color: "var(--cs-fg2)" }}>Real benefits funded by our safety partners.</p>

      <div className="mt-5 space-y-3">
        {items.map((b) => {
          const Icon = CAT_ICON[b.category] || Heart;
          const color = CAT_COLOR[b.category] || "var(--cs-magenta)";
          return (
            <div key={b.id} data-testid={`wallet-benefit-${b.id}`} className="cs-card p-4">
              <div className="flex items-start gap-3">
                <span className="grid place-items-center rounded-xl flex-shrink-0" style={{ width: 48, height: 48, background: `${color}22` }}>
                  <Icon size={24} style={{ color }} />
                </span>
                <div className="flex-1">
                  <p className="font-head font-bold text-lg leading-tight">{b.title}</p>
                  <p className="text-sm" style={{ color: "var(--cs-fg2)" }}>{b.detail}</p>
                  <p className="text-[11px] mt-1" style={{ color: "#52525b" }}>Funded by {b.sponsor}</p>
                </div>
              </div>
              <button data-testid={`wallet-redeem-${b.id}`} onClick={() => redeem(b)} disabled={b.redeemed && b.cta === "show"}
                className="cs-tap w-full mt-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2"
                style={{ height: 46, background: b.redeemed ? "rgba(16,185,129,0.15)" : "var(--cs-card-hi)", border: `1px solid ${b.redeemed ? "var(--cs-green)" : "var(--cs-border)"}`, color: b.redeemed ? "var(--cs-green)" : "#fff" }}>
                {b.redeemed ? <><Check size={16} /> Claimed</> : b.action}
              </button>
            </div>
          );
        })}
      </div>
      <p className="text-center text-xs mt-5 mb-2" style={{ color: "#52525b" }}>
        Partners fund useful safety outcomes — not ad space.
      </p>
    </Page>
  );
}
